//import './nav-bar-account-buttons-component.js'

class NavBarComponent extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('customer-logged-in', () => {
      document.getElementById('visitor-nav-items').classList.add('d-none')
      document.getElementById('customer-nav-items').classList.remove('d-none')
    }, true)
    document.addEventListener('customer-logged-out', () => {
      document.getElementById('visitor-nav-items').classList.remove('d-none')
      document.getElementById('customer-nav-items').classList.add('d-none')
    }, true)
  }

  connectedCallback() {
    this.innerHTML = String.raw`
  <nav class="navbar navbar-expand-md fixed-top bg-light hidden-print">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"/></svg>
        <!--<i class="glyphicon glyphicon-equalizer"></i>-->
        Beam Designer
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0">


          <!-- File -->
          <li class="nav-item dropdown mx-2">
            <a class="nav-link" href="#" id="file-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              File
            </a>
            <ul class="dropdown-menu" aria-labelledby="file-dropdown">
              <li><a class="dropdown-item" href="#" onclick="openNewBeamDialog()"><i class="fa fa-fw fa-file"></i> New</a></li>
              <li><a class="dropdown-item" href="#" onclick="openFileExlporerDialog()"><i class="fa fa-fw fa-folder"></i> Open</a></li>
              <li><a class="dropdown-item" href="#" onclick="saveActiveProject()"><i class="fa fa-fw fa-save"></i> Save</a></li>
              <li><a class="dropdown-item" href="#" onclick="openMakeCopyDialog();"><i class="fa fa-fw fa-copy"></i> Make a copy...</a></li>
              <li><a class="dropdown-item" href="#" onclick="openPrintPreferencesDialog();"><i class="fa fa-fw fa-print"></i>Print...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modal-project-header-settings-dialog">
                <i class="fa fa-fw fa-edit"></i> Rename</a>
              </li>
              <li><a class="dropdown-item" href="#" onclick="openDeleteProjectDialog();"><i class="fa fa-fw fa-trash"></i>Delete</a></li>
            </ul>
          </li>

          <!-- Edit -->
          <li class="nav-item dropdown mx-2">
            <a class="nav-link" href="#" id="edit-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Edit
            </a>
            <ul class="dropdown-menu" aria-labelledby="edit-dropdown">
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                  data-bs-target="#modal-material-dialog">Material...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#modal-shape-dialog">Shape...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#modal-design-dialog">Design...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                  data-bs-target="#modal-span-dialog">Spans...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#modal-load-dialog">Loads...</a></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#modal-bracing-dialog">Bracing...</a></li>
            </ul>
          </li>

          <!-- *** Help *** -->
          <li class="nav-item dropdown mx-2">
            <a class="nav-link" href="#" id="help-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Help
            </a>
            <ul class="dropdown-menu" aria-labelledby="help-dropdown">
              <li>
                <a class="dropdown-item" href="steel-beam-how-to.html" >How to Design a Steel Beam</a>
              </li>
              <li>
                <a class="dropdown-item" href="flitch-beam-how-to.html" >How to Design a Wood Flitch Beam</a>
              </li>
              <li>
                <a class="dropdown-item" href="save-steel-and-wood-beam-designs.html">How to Save Projects</a>
              </li>
              <li>
                <a class="dropdown-item" href="mailto:jeff@webstructural.com">Contact us</a>
              </li>
            </ul>
          </li>

          <!-- *** Units *** -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="units-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              English Units
            </a>
            <ul class="dropdown-menu" aria-labelledby="units-dropdown">
              <li><a class="dropdown-item" href="#" id="english-units-button">English Units</a></li>
              <li><a class="dropdown-item" href="#" id="metric-units-button">Metric Units</a></li>
            </ul>
          </li>
        </ul>

        <ul class="nav" id="">
          <li class="nav-item dropdown mx-2">
            <a class="nav-link hidden-print" type="button" href="#" id="apps-dropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="fa fa-th fa-fw"></i> Apps
            </a>
            <ul class="dropdown-menu" aria-labelledby="apps-dropodown">
              <li><a class="dropdown-item" href="beam-designer.html">Beam Design</a></li>
              <li><a class="dropdown-item" href="anchor-bolt-designer.html">Anchor Design</a></li>
              <li><a class="dropdown-item" href="footing-designer.html">Footing Design</a></li>
            </ul>
          </li>

        </ul>
        
        <ul class="nav d-flex" id="visitor-nav-items">

          <li class="nav-item"><button type="button" class="btn btn-primary navbar-btn hidden-print" data-bs-toggle="modal"
              data-bs-target="#modal-sign-up-form" id="navbar-create-account-button">Create an Account</button>
          </li>
          <li class="nav-item" style="margin-left:4px;"><button type="button" class="btn btn-default navbar-btn hidden-print" data-bs-toggle="modal"
              data-bs-target="#modal-login-form" id="login-button"><i class="fa fa-sign-in fa-fw"></i>
              Login</button>
          </li>
        </ul>
        
        <ul class="nav d-flex" id="customer-nav-items">
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="customLoggedInDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <span id="signed-in-as">Pro Customer</span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="customLoggedInDropdown">
              <li><a class="dropdown-item" href="account.html">My Account</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modal-logout-form">Logout</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

    `

    document.getElementById('english-units-button').onclick = () => {
      document.getElementById('units-dropdown').innerHTML = "English Units"
      onEnglishUnitsClicked()
    }
    document.getElementById('metric-units-button').onclick = () => {
      document.getElementById('units-dropdown').innerHTML = "Metric Units"
      onMetricUnitsClicked()
    }
  }
}

customElements.define('nav-bar-component', NavBarComponent);